module.exports = __webpack_public_path__ + "static/img/s24.e1a2e546.png";